// import React from "react";
// import { Col, Row, Tab } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
// import Fade from "react-reveal/Fade";
// import { PrincipaleButton } from "../PrincipaleButton";
// import { Link } from "react-router-dom";
// const PricingCard = ({ data, id }) => {
//   return (
//     <Tab.Pane eventKey={id + 1}>
//       <Row>
//         {data.map(({ title, name, price }, index) => {
//           return (
//             <Col md={4} key={index}>
//               <Fade bottom duration={1800} distance="40px">
//                 <div className={`pricingCard pricingCard${id + 1}`}>
//                   <div className="pricingBox">
//                     <h4>{title}</h4>
//                     <p className="pricePlan">
//                       <span className={`ph${id + 1}`}>${price}/</span>month
//                     </p>
//                     <h5>{name}</h5>
//                     <p className="planDescription">
//                       Pellentesque nibh. Aenean quam. In scelerisque sem at
//                       dolor. Maecenas mattis. Sed convallis tristique sem.
//                     </p>
//                   </div>
//                   <li>
//                     <span className="checkIcon">
//                       <FontAwesomeIcon icon={faCheckCircle} />
//                     </span>{" "}
//                     First Description.
//                   </li>
//                   <li>
//                     <span className="checkIcon">
//                       <FontAwesomeIcon icon={faCheckCircle} />
//                     </span>{" "}
//                     Second Description
//                   </li>
//                   <li>
//                     <span className="checkIcon">
//                       <FontAwesomeIcon icon={faCheckCircle} />
//                     </span>{" "}
//                     Third Description
//                   </li>
//                   <Link to="/signup">
//                     {" "}
//                     <PrincipaleButton>Subscribe</PrincipaleButton>
//                   </Link>
//                 </div>
//               </Fade>
//             </Col>
//           );
//         })}
//       </Row>
//     </Tab.Pane>
//   );
// };

// export default PricingCard;
import React from "react";
import { Col, Row, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion"; // Import framer-motion
import { PrincipaleButton } from "../PrincipaleButton";
import { Link } from "react-router-dom";

const PricingCard = ({ data, id }) => {
  return (
    <Tab.Pane eventKey={id + 1}>
      <Row>
        {data.map(({ title, name, price }, index) => {
          return (
            <Col md={4} key={index}>
              <motion.div // Wrap the component with motion.div
                initial={{ opacity: 0, y: 40 }} // Initial animation properties
                animate={{ opacity: 1, y: 0 }} // Animation properties
                transition={{ duration: 1 }} // Animation duration
                className={`pricingCard pricingCard${id + 1}`}
              >
                <div className="pricingBox">
                  <h4>{title}</h4>
                  <p className="pricePlan">
                    <span className={`ph${id + 1}`}>${price}/</span>month
                  </p>
                  <h5>{name}</h5>
                  <p className="planDescription">
                    Pellentesque nibh. Aenean quam. In scelerisque sem at
                    dolor. Maecenas mattis. Sed convallis tristique sem.
                  </p>
                </div>
                <li>
                  <span className="checkIcon">
                    <FontAwesomeIcon icon={faCheckCircle} />
                  </span>{" "}
                  First Description.
                </li>
                <li>
                  <span className="checkIcon">
                    <FontAwesomeIcon icon={faCheckCircle} />
                  </span>{" "}
                  Second Description
                </li>
                <li>
                  <span className="checkIcon">
                    <FontAwesomeIcon icon={faCheckCircle} />
                  </span>{" "}
                  Third Description
                </li>
                <Link to="/signup">
                  <PrincipaleButton>Subscribe</PrincipaleButton>
                </Link>
              </motion.div>
            </Col>
          );
        })}
      </Row>
    </Tab.Pane>
  );
};

export default PricingCard;

